module.exports = __webpack_public_path__ + "static/media/theatermask.4a978f22.svg";